import React from "react"

import { useAppDispatch, useAppSelector } from "@/store"
import {
  clearChangePasswordPrompt,
  resumeConnectRemoteDesk,
  selectChangePasswordPrompt,
} from "@/stores/login_slice"
import { AppDialog } from "@/widgets/AppDialog"
import { goToResetPassword } from "@/utils/platform"
import { useNavigate } from "react-router-dom"

/** 登录成功后、连接云桌面前，提示用户修改初始密码的弹窗。 */
const ChangePasswordReminderDialog: React.FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const prompt = useAppSelector(selectChangePasswordPrompt)

  // 暂不修改：关闭弹窗并继续连接云桌面
  const handleCancel = async () => {
    try {
      await dispatch(resumeConnectRemoteDesk()).unwrap()
      navigate("/remoteDesk")
    } catch (e) {
      console.error("resumeConnectRemoteDesk error: ", e)
    }
  }

  // 去修改：清除提示并跳转重置密码页
  const handleConfirm = () => {
    dispatch(clearChangePasswordPrompt())
    goToResetPassword()
  }

  return (
    <AppDialog
      isOpen={prompt !== null}
      title={prompt?.message ?? ""}
      confirmText="去修改"
      cancelText="暂不修改"
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  )
}

export default ChangePasswordReminderDialog
